import FullScreenLoader from "@/components/loading/FullScreenLoader"
import { useLocalSearchParams, useRouter } from "expo-router"
import { useEffect, useState } from "react"
import sdk from "@/api/sdk"
import { showErrorToast } from "@/components/toasts/AppToast"
import WebView from "react-native-webview"
import { Sentry } from "@/hooks/sentry"
import { analysisSubmitted } from "@/analytics/events/analyzer"
import { updatePlace } from "@/stores/analysisDataStore"

export function parseAddress(input: string): string | null {
  // Define a regular expression to match the address pattern in Zillow URLs
  const urlAddressRegex = /\/([A-Za-z0-9-_]*[-_]\d{5})[-_/]/

  if (
    input.toLowerCase().includes("realtor.com") &&
    input.toLowerCase().includes("\n")
  ) {
    // special case realtor.com..
    return input.split("\n")[1]
  }

  const match = input.match(urlAddressRegex)
  console.log(input, match)

  return match ? match[1].replace(/[-_]/g, " ") : null
}

export function parseImportSource(input: string): string | undefined {
  const domainRegex = /([A-Za-z]*\.com)\//

  return input.match(domainRegex)?.[1]
}

export default function Import() {
  const { text } = useLocalSearchParams()

  const [status, setStatus] = useState("Looking up address from url...")
  const router = useRouter()

  const [url, setUrl] = useState<string | undefined>()
  const [address, setAddress] = useState<string | undefined>()
  const [, setSource] = useState<string | undefined>()

  useEffect(() => {
    void (async () => {
      console.log(text)
      Sentry.addBreadcrumb({
        message: "Import started",
        data: {
          text,
        },
      })

      // Shortened Urls will have to be followed..
      if (text?.includes("redf.in")) {
        setUrl(text as string)
        return
      }

      const address = parseAddress(text as string)

      if (address) {
        setAddress(address)
        setSource(parseImportSource(text as string))
      } else {
        Sentry.captureException(
          new Error(`Couldn't get address from string: "${text as string}"`)
        )
        setStatus("Could not find property from share. Please enter manually.")
      }
    })()
  }, [text])

  useEffect(() => {
    if (!address) {
      return
    }
    void (async () => {
      setStatus(`Looking up data about "${address}"`)
      const { googlePlaces } = await sdk.PropertyAutocomplete({ address })

      if (!googlePlaces || googlePlaces.length < 1) {
        setStatus(`Failed to lookup address ${address}`)
        showErrorToast({
          title: "Could not find address",
          message: `${address} was not found on Google`,
        })
        router.back()
        return
      }

      const placeId = googlePlaces[0]?.placeId

      Sentry.addBreadcrumb({
        message: `PlaceId for ${address}`,
        data: {
          placeId,
          googlePlaces,
        },
      })

      if (placeId) {
        const fullAddress = googlePlaces[0]?.address!
        // @ts-expect-error its there.
        const street = googlePlaces[0]?.street

        analysisSubmitted({ propertyAddress: fullAddress })
        updatePlace({ placeId, street, fullAddress })
        router.replace(`/analyze/search/${placeId}`)
      } else {
        //
        setStatus("Could not find address")
        setTimeout(() => {
          router.replace("/analyze/search")
        }, 800)
      }
    })()
  }, [address])

  return (
    <FullScreenLoader>
      {status}
      {url && (
        <WebView
          source={{ uri: url }}
          onNavigationStateChange={(e) => {
            if (e.url.includes("redfin.com")) {
              setSource("redfin.com")
              if (e.title.includes("|")) {
                setAddress(e.title.split("|")[0])
              } else {
                const address = parseAddress(e.url)
                if (address) {
                  setAddress(address)
                } else {
                  setStatus("Could not find property from share")
                }
              }
            }
          }}
          style={{ width: 300, height: 1, opacity: 0 }}
        />
      )}
    </FullScreenLoader>
  )
}
